import React, { useState, useEffect, useRef } from "react";
// import { useHistory, useLocation } from 'react-router-dom';
import Header from "../../../../Components/Header/Header";
import Badge from "react-bootstrap/Badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { Container, Row, Col, Modal, Dropdown } from "react-bootstrap";
import { faPlus, faXmark, faCircle, faPaperclip, faCaretDown, faBolt, faEllipsis, faLink, faCircleCheck, faChevronDown, faGear, faPencil, faBarcode, faRotateRight, faPen } from "@fortawesome/free-solid-svg-icons";

import Export from "../../../../assets/images/export.svg";
import View from "../../../../assets/images/view.svg";
import { Button, ProgressBar, Form, Table } from "react-bootstrap";

import Cargoplane from "../../../../assets/images/plane.svg";
import Cuser from "../../../../assets/images/cuser.png";
import Cargotruck from "../../../../assets/images/cargo-truck.png";
import { Link } from "react-router-dom";
import ActivityComments from "../../../../Components/common/ActivityComments";
import ImageUpload from "../../../../Components/common/ImageUpload";
import {
  GETULDDETAILS,
  MVTHDETAILS,
  TRUCKORDERSDETAILS,
} from "../../../../Utils/conts";
import { withRFSToken } from "../../../../Services/axios";
import Accordion from "react-bootstrap/Accordion";
import LeftMenu from "../../../../Components/LeftMenu/LeftMenu";
import { toast } from "react-toastify";
import Rapdf from "../../../../assets/images/pdf.png";
import DelayD from "../../../../assets/images/delay_not_active.png";
import DelayA from "../../../../assets/images/delay_active.png";
import Select from 'react-select';
import Tripimg from "../../../../assets/images/edit.png";
import Planned from "../../../../assets/images/planned2.png";
import pen from "../../../../assets/images/pen.png";

const OrdersViewDetails = ({ onNav }) => {
  const queryParameters = new URLSearchParams(window.location.search);
  const Uldid = queryParameters.get("id");
  const detailsType = queryParameters.get("type");
  const backTab = queryParameters.get("tab");

  let storedData = localStorage.getItem("OVDetails");

  if (storedData) {
    storedData = JSON.parse(storedData);
  }
  const [operationDate, setOperationDate] = useState("");
  const [operationTime, setOperationTime] = useState("");
  const [disLoading, setDisLoading] = useState(false);

  const [gridData, setGridData] = useState([]);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [gridSelect, setGridSelect] = useState([]);
  const gridRef = useRef(null);
  const isMounted = useRef(false);

  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [schdlModalData, setSchdlModalData] = useState('');
  const [orderVehicle, setOrderVehicle] = useState();
  const [modalData, setModalData] = useState({});
  const [statusData, setStatusData] = useState([]);
  const [awbsData, setAwbsData] = useState([]);
  const [isModal, setIsModal] = useState(false);
  const [editStatusIndex, setEditStatusIndex] = useState(false);
  const [docStatus, setDocStatus] = useState('O');
  const [editModa, setEditModa] = useState(false);

  const loadDetails = async (id) => {
    setDisLoading(true);
    try {
      const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: id });
      // .then(function (res) {
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data;

        setSelectedRowData(innerData);
        setGridData(innerData.awbs);
        setMrnCrm({ mrn: innerData?.mrn || "", crm: innerData?.crm || "" });
        setEditMrnCrm("");
      } else {
        toast.error("No Details found");
        setDisLoading(false);
      }

      // });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (isMounted.current) return;
    const detailsData = JSON.parse(localStorage.getItem("OVDetails"));
    if (detailsData) {
      loadDetails(detailsData);
    }
    // const operationDateTime = storedData.Form.operation_date;
    // if (operationDateTime) {
    //     const [opDate, opTime] = operationDateTime.split(' ');
    //     setOperationDate(opDate);
    //     setOperationTime(opTime);
    // }

    // setSelectedRowData(detailsData)
    // setGridData(storedData.ULD.awbs)
    isMounted.current = true;
  }, []);

  // const history = useHistory();
  // const location = useLocation();

  // if (Uldid){
  //     setUldNumber(Uldid);
  //     queryParameters.delete('uld_number');
  //     history.push({
  //         pathname: location.pathname,
  //       });
  //     window.location.replace('/ULDControl/MovementHistory')
  // }
  const [uldNumber, setUldNumber] = useState(Uldid);

  useEffect(() => {
    if (gridRef.current) {
      if (gridData) {
        // const localData = gridData[activeTab].map(item => ({

        //     id: item.id,
        //     STN: item.station_code,
        //     Taddrs: item.station_addresses.length,
        //     Address: item.station_addresses // ?.join(', ')Join the address array into a string
        // }));
        // console.log("🚀 ~ localData ~ localData:", localData)
        const source = {
          datatype: "json",
          id: "",
          datafields: [
            { name: "id", type: "string" },
            { name: "awb_id", type: "string" },
            { name: "airway_bill", type: "string" },
            { name: "pick_status", type: "string" },
            { name: "pieces", type: "string" },
            { name: "rcf", type: "string" },
            { name: "man", type: "string" },
            { name: "msca", type: "string" },
            { name: "package", type: "string" },
            { name: "uld_number", type: "string" },
            { name: "weight", type: "string" },
            { name: "volume", type: "string" },
            { name: "lm", type: "string" },
            { name: "nature_of_goods", type: "string" },
          ],
          localdata: gridData,
        };

        const dataAdapter = new window.$.jqx.dataAdapter(source);
        // console.log('localdata', source.localdata)
        const columns = [
          { text: "Airway Bill", datafield: "airway_bill", width: "8%" },
          {
            text: "Pickup Status",
            datafield: "pick_status",
            width: "11%",
            cellsrenderer: (
              row,
              columnfield,
              value,
              defaulthtml,
              columnproperties
            ) => {
              if (value && Array.isArray(value)) {
                // Generate multiple divs for each item in the array
                const content = value
                  .map(
                    (item) =>
                      `<div class="${item.color_status || ""}">${item.status || ""
                      }</div>`
                  )
                  .join(""); // Combine all divs into a single string

                return `<div class="stats_view">${content}</div>`;
              }
              // Fallback if value is not an array or empty
              return defaulthtml;
            },
          },
          { text: "Pcs", datafield: "pieces", width: "7%" },
          { text: "RCF", datafield: "rcf", width: "7%" },
          { text: "MAN", datafield: "man", width: "7%" },
          { text: "MSCA", datafield: "msca", width: "7%" },
          { text: "Package", datafield: "package", width: "8%" },
          { text: "ULD No.", datafield: "uld_number", width: "10%" },
          { text: "Weight", datafield: "weight", width: "8%" },
          { text: "Volume", datafield: "volume", width: "8%" },
          { text: "LM", datafield: "lm", width: "8%" },
          {
            text: "Nature of Goods",
            datafield: "nature_of_goods",
            width: "8%",
          },
        ];

        const gridOptions = {
          width: "100%",
          source: dataAdapter,
          columns: columns,
          autoheight: true,
          sortable: true,
          altrows: false,
          enabletooltips: true,
          editable: false,
          // selectionmode: 'checkbox',
          pageable: true,
          pageSize: 10,
          pagerButtonsCount: 5,
          pagerMode: "advanced",
          filterable: true,
          filterrowheight: 45,
          showfilterrow: true,
          rowsheight: 42,
          columnsheight: 45,
        };

        window.$(gridRef.current).jqxGrid(gridOptions);
        window
          .$(gridRef.current)
          .find(".jqx-grid-column-header")
          .css("background-color", "white");

        window
          .$(gridRef.current)
          .find('div[role="row"]')
          .each((index, row) => {
            window.$(row).on("mouseover", () => {
              window.$(row).addClass("row-hover");
            });
            window.$(row).on("mouseout", () => {
              window.$(row).removeClass("row-hover");
            });
          });
        //   window.$(gridRef.current).off('cellclick');
        //   window.$(gridRef.current).on('cellclick', (event) => {
        //     const args = event.args.row.bounddata;
        //     // if (event.args.columnindex > 0) {
        //     // if (gridSelect) {
        //     //     gridSelect.forEach(item => {
        //     //         const selectedRowBoundIndex = item.boundindex;
        //     //         window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
        //     //     });
        //     // }
        //     loadHistory(args.uld_number);
        //     // }
        //   });
      } else {
        const columns = [
          {
            text: "Stations",
            filtertype: "textbox",
            datafield: "STN",
            width: "50%",
          },
          {
            text: "Total Address",
            filtertype: "textbox",
            datafield: "Taddrs",
            width: "50%",
          },
        ];
      }
    }
  }, [gridData, selectedRowData]);

  // upload forward
  const imageUploadRef = useRef(null);
  const browseClick = () => {
    if (imageUploadRef.current) {
      imageUploadRef.current.handleBrowseFiles();
    }
  };
  // end
  // const loadDetails = async (uldNumber) => {
  //     try {
  //         const res = await withRFSToken.post(GETULDDETAILS, { uld_number: uldNumber })
  //             .then(function (res) {
  //                 const innerData = res.data.response_data;
  //                 console.log("🚀 ~ .then ~ innerData:654", innerData)
  //                 setSelectedRowData(innerData);

  //             });
  //     } catch (error) {
  //         console.error('Error fetching data:', error);
  //     }
  // }
  const [mrnCrm, setMrnCrm] = useState({});
  const [editMrnCrm, setEditMrnCrm] = useState("");
  const handleEdtitMrnCrm = (pos) => {
    if (pos == "mrn") {
      setMrnCrm({ mrn: selectedRowData.mrn || "" });
    } else {
      setMrnCrm({ crm: selectedRowData.crm || "" });
    }
    setEditMrnCrm(pos);
  };
  const changeMrnCrm = (e) => {
    console.log("e", e.target.value);

    const { name, value } = e.target;
    setMrnCrm({ [name]: value });
  };
  const updateMrnCrm = async (pos) => {
    const checkParam = mrnCrm?.mrn
      ? mrnCrm?.mrn != selectedRowData.mrn
      : mrnCrm?.crm != selectedRowData.crm;
    if (checkParam) {
      const payload = { ...mrnCrm, order_id: selectedRowData.order_id };
      console.log(
        "🚀 ~ updateMrnCrm ~ payload:",
        mrnCrm?.mrn,
        selectedRowData.mrn
      );
      try {
        const res = await withRFSToken.post("monitor/update-mrn-crm", payload);
        // .then(function (res) {
        if (res.data.response_code === 200) {
          const innerData = res.data.response_data;
          toast.success(res.data.response_msg);
          setMrnCrm({});
          setEditMrnCrm("");
          loadDetails(selectedRowData.order_id);
        } else {
          toast.error(res.data.response_msg);
        }
        // });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    } else {
      // toast.warning('Please change the data before update')
      setMrnCrm({});
      setEditMrnCrm("");
    }
  };
  const [schdlModal, setSchdlModal] = useState(false);
  const [selectedScheduleData, setSelectedScheduleData] = useState();
  const openLoadingModal = (e) => {
    setSchdlModal(true);
    setChangedData((prev) => ({
      ...prev,
      officeIn: selectedRowData.loading_office_in,
      officeOut: selectedRowData.loading_office_out,
      startLoading: selectedRowData.loading_start,
      endLoading: selectedRowData.loading_end,
    }));
    const selectedScheduleDataassign = {
      order_id: selectedRowData.order_id,
      order_type: "Loading",
    };
    setSelectedScheduleData(selectedScheduleDataassign);
  };
  const openUnLoadingModal = (e) => {
    setSchdlModal(true);
    setChangedData((prev) => ({
      ...prev,
      officeIn: selectedRowData.unloading_office_in,
      officeOut: selectedRowData.unloading_office_out,
      startLoading: selectedRowData.unloading_start,
      endLoading: selectedRowData.unloading_end,
      gateIn: selectedRowData.get_in,
      gateOut: selectedRowData.get_out,

    }));
    const selectedScheduleDataassign = {
      order_id: selectedRowData.order_id,
      order_type: "Unloading",
    };
    setSelectedScheduleData(selectedScheduleDataassign);
  };
  const [changedData, setChangedData] = useState({
    officeIn: "",
    officeOut: "",
    startLoading: "",
    endLoading: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setChangedData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const updateTime = async () => {
    const res = await withRFSToken
      .post("monitor/update-trip-time", {
        order_id: selectedScheduleData.order_id,
        order_type: selectedScheduleData.order_type,
        office_in: changedData.officeIn,
        office_out: changedData.officeOut,
        start_time: changedData.startLoading,
        end_time: changedData.endLoading,
      })
      .then(function (res) {
        setSchdlModal(false);
        if (res.data.response_code == 200) {
          toast.success(res.data.response_msg);
          window.location.reload();
        } else {
          toast.error(res.data.response_msg);
        }
      });
  };

  const selectedOrder = orderVehicle?.find(
    truck => truck.order_id === selectedOrderId
  );
  const delayOptions = [
    { value: 'Cargo did not fit', label: 'Cargo did not fit' },
    { value: 'Custom Inspection', label: 'Custom Inspection' },
    { value: 'NCTS failure', label: 'NCTS failure' },
    { value: 'Unable to locate', label: 'Unable to locate' },
    { value: 'Incorrect trailor', label: 'Incorrect trailor' },
  ];
  const updateIrregularity = async () => {
    const payload = Object.entries(changedData.orders).map(([order_id, data]) => ({
      order_id,
      delay_status: data.delay_status,
      delay_remarks: data.delay_remarks,
    }));

    const res = await withRFSToken.post('monitor/set-delay', { delay_data: payload })
      .then(function (res) {
        if (res.data.response_code == 200) {
          window.location.reload();
        }
      });
  };
  const sideBarDelayClick = () => {
    setSchdlModalData('DEL')
    monitor_order_vehicle(selectedRowData.order_id);
    setSchdlModal(true)
  };
  const sideBarTripStatusClick = () => {
    setSchdlModalData('SCH')
    monitor_order_vehicle(selectedRowData.order_id);
    let order_type = "";
    if (selectedRowData.loading_edit === 1) {
      order_type = "Loading";
    } else if (selectedRowData.unloading_edit === 1) {
      order_type = "Unloading";
    }
    const selectedScheduleDataassign = {
      'order_id': selectedRowData.order_id,
      'order_type': order_type,
    };
    setSchdlModal(true)
    setSelectedScheduleData(selectedScheduleDataassign);
    setChangedData(prev => ({
      ...prev,
      officeIn: selectedRowData.loading_office_in ?? selectedRowData.unloading_office_in,
      officeOut: selectedRowData.loading_office_out ?? selectedRowData.unloading_office_out,
      startLoading: selectedRowData.loading_start ?? selectedRowData.unloading_start,
      endLoading: selectedRowData.loading_end ?? selectedRowData.unloading_end,
      gateIn: selectedRowData.get_in,
      gateOut: selectedRowData.get_out
    }));
  };
  const monitor_order_vehicle = async (orderId) => {
    try {
      const res = await withRFSToken.post('monitor/order-vehicle', { order_id: orderId })
        .then(function (res) {
          if (res.data.response_code == 200) {
            setOrderVehicle(res.data.response_data);
            // setChangedData(prev => {
            //     const response = res?.data?.response_data;
            //     const firstItem = Array.isArray(response) && response.length > 0 ? response[0] : null;
            //     return {
            //         ...prev,
            //         delay_status: firstItem?.delay_status ? JSON.parse(firstItem.delay_status) : null,
            //         delay_remarks: firstItem?.delay_remarks ?? null,
            //     };
            // });
            setChangedData(prev => {
              const response = res?.data?.response_data;
              const orders = {};

              if (Array.isArray(response)) {
                response.forEach(item => {
                  orders[item.order_id] = {
                    delay_status: item.delay_status ? JSON.parse(item.delay_status) : [],
                    delay_remarks: item.delay_remarks ?? '',
                  };
                });
              }

              return {
                ...prev,
                orders, // <- this is the key where you store all order-wise data
              };
            });
          }
        });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  useEffect(() => {
    if (orderVehicle?.length > 0 && selectedOrderId === null) {
      setSelectedOrderId(orderVehicle[0].order_id);
    }
  }, [orderVehicle]);
  const sideBarUpdateClick = async (id, pos) => {
    setDisLoading(true);
    try {
      const res = await withRFSToken.post(TRUCKORDERSDETAILS, { order_id: id });
      // .then(function (res) {
      if (res.data.response_code === 200) {
        const innerData = res.data.response_data;
        if (pos === 'S') {
          setModalData(innerData);
          setStatusData(innerData.awbs);
          setAwbsData(innerData.awbs);
          setIsModal(true);
          setEditStatusIndex(false);
          if (innerData.doc_status) {
            setDocStatus(innerData.doc_status)
          }
        } else {
          setSelectedRowData(innerData);
          setMrnCrm({ mrn: innerData?.mrn || '', crm: innerData?.crm || '' })
          setEditMrnCrm('')
        }
        setDisLoading(false);
      } else {
        toast.error('No Details found');
        setDisLoading(false);
      }

      // });
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }
  const closeModal = () => {
    setIsModal(false);
    setDocStatus('O');
    setEditStatusIndex(false);
  };
  const handleRadioChange = (e) => {
    if (docStatus == 'C') {
      if (e.target.value == 'O' || e.target.value == 'P') {
        const updatedStatusData = awbsData.map(item => ({
          ...item,
          pick_status: [
            { status: "rcf", color_status: "rcf_class" }
          ],
          man: '',
        }));
        setStatusData(updatedStatusData);
      }
    }
    setDocStatus(e.target.value);
    if (e.target.value === 'C') {
      const updatedStatusData = awbsData.map(item => ({
        ...item,
        pick_status: [
          // ...item.pick_status,
          { status: "rfp", color_status: "rfp_class" }
        ],
        man: Number(item.pieces),
        rcf: item.rcf
      }));
      setStatusData(updatedStatusData);
    } else {

      if (docStatus !== 'C') {
        const allRfp = awbsData.every(item => item.pick_status[0].status === "rfp");
        if (allRfp) {

        } else {
          const updatedStatusData = awbsData.map(item => ({
            ...item,
            pick_status: item.pick_status,
            man: item.man == null ? '' : item.man,
            rcf: item.rcf
          }));
          setStatusData(updatedStatusData);
        }
      }
    }
    setEditStatusIndex(false);
  };
  const handleFieldChange = (index, field, value) => {
    const updatedData = structuredClone(statusData)// [...statusData];
    // const numericValue = value == '' ? null : value == '0' ? null : Number(value)
    const numericValue = value == '' ? null : Number(value)
    updatedData[index][field] = numericValue;
    setStatusData(updatedData);
    if (docStatus == 'C' || docStatus == 'O' || docStatus == 'P') {
      const pieces = Number(updatedData[index].pieces);
      const man = updatedData[index].man;
      const rcf = updatedData[index].rcf;
      if (field == 'man') {
        if (statusData.length === 1) { setDocStatus('C') }
        if (numericValue < pieces) {
          updatedData[index].pick_status = [
            // ...updatedData[index].pick_status,
            { status: "rfp", color_status: "rfp_class" },
            { status: "msca", color_status: "msca_class" }
          ];
          // setDocStatus('P')
        } else if (numericValue >= pieces) {

          updatedData[index].pick_status = [
            // ...updatedData[index].pick_status,
            { status: "rfp", color_status: "rfp_class" }
          ];
        }

        if (numericValue == null) {
          if (!statusData[index].rcf || statusData[index].rcf == '') {
            updatedData[index].pick_status = [];
          } else if (pieces == statusData[index].rcf) {
            updatedData[index].pick_status = [
              { status: "rcf", color_status: "rcf_class" }
            ];
          } else if (pieces > statusData[index].rcf) {
            updatedData[index].pick_status = [
              { status: "rcf", color_status: "rcf_class" },
              { status: "msca", color_status: "msca_class" }
            ];
          }
        }
        setEditModa(true);
        // console.log('===> MAN numericValue', numericValue);
        // const updatedStatusData = modalData.nestedData.map(item => ({
        //     ...item,
        //     pick_status: item.pick_status,
        // }));
      } else if (field == 'rcf') {
        console.log('===> RCF numericValue', numericValue);
        if (numericValue <= pieces) {
          if (statusData[index].man < pieces) {
            updatedData[index].pick_status = [
              { status: "rfp", color_status: "rfp_class" },
              { status: "msca", color_status: "msca_class" }
            ];
          } else if (statusData[index].man == pieces) {
            updatedData[index].pick_status = [
              { status: "rfp", color_status: "rfp_class" }
            ];
          }
        }
        if (numericValue == pieces) {
          if (!statusData[index].man || statusData[index].man == '') {
            updatedData[index].pick_status = [
              { status: "rcf", color_status: "rcf_class" }
            ];
          }
        }
        if (numericValue < pieces) {
          if (!statusData[index].man || statusData[index].man == '') {
            updatedData[index].pick_status = [
              { status: "rcf", color_status: "rcf_class" },
              { status: "msca", color_status: "msca_class" }
            ];
          }
        }
        if (numericValue == null) {
          if (!statusData[index].man || statusData[index].man == '') {
            updatedData[index].pick_status = [];
          }
        }
      }
    }
    setStatusData([...updatedData]);
  };
  const handleEditCompleteRow = () => {
    setEditStatusIndex(false);
  };
  const updateStatus = async () => {
    const updateData = statusData.map((row, index) => {
      return {
        awb_id: row.id, // Identify the row by its unique field monitor/order-doc-update
        pieces: row.pieces,
        rcf: row.rcf,
        man: row.man
      };
    }).filter(Boolean);
    const payload = { order_id: modalData.order_id, doc_status: docStatus, awbs: updateData }
    try {
      const res = await withRFSToken.post('monitor/order-doc-update', payload)
        .then(function (res) {
          const innerData = res;
          if (res.data.response_code == 200) {
            // setSelectedRowData(res.data.response_data);
            toast.success(res.data.response_msg);
            setIsModal(false);
            window.location.reload();
          } else if (res.data.response_code == 400) {
            toast.warning(res.data.response_msg)
          } else {
            toast.error(res.data.response_msg)
          }
        });

    } catch (error) {
      console.error('Error sending request:', error);
    }
  };
  const handleEditRow = (index) => {
    setEditStatusIndex(index);
  };

  useEffect(() => {
    if (editModa) {
      if (statusData.length > 1) {
        // console.log('xxxxxx');
        const hasMissingMan = statusData.some(row => row.man === null || row.man === '' || row.man === undefined);
        if (hasMissingMan) {
          setDocStatus('P');
        } else {
          const allManValid = statusData.every(row => Number(row.man) >= 0);
          if (allManValid) {
            setDocStatus('C');
          }
        }
      }
    }

  }, [statusData])

  return (
    <>
      {/* {console.log('selectedRowData', storedData)} */}
      {/* <div className="">
        <Header />
        <div className="schedule">
          <LeftMenu />
          <div className="main-panel"> */}
      <div className="main-content">
        <Link to='#' onClick={() => onNav({ path: 'OV', name: 'Order View', heading: 'RFS - Order View', })} className="stk_back">

          <FontAwesomeIcon icon={faArrowLeft} /> Back
        </Link>
        <div className="maindiv">
          <div className="SecondDiv mt-3">
            {/* <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button> */}
            <div className="girddtals_header">
              <h3>
                {selectedRowData?.order_number} &nbsp;
                <span className="position-relative">
                  {selectedRowData?.pick_status &&
                    Array.isArray(selectedRowData?.pick_status)
                    ? selectedRowData?.pick_status.map((item) => (
                      <>
                        {/* <div class=""> */}
                        <div
                          class={`mt-0 ${item.color_status}`}
                          style={{
                            position: "absolute",
                            top: "1px",
                            left: "0",
                          }}
                        >
                          {item.status || ""}
                        </div>
                        {/* </div> */}
                      </>
                    ))
                    : ""}
                </span>
                <a href={selectedRowData?.loading_advice} target="blank">
                  <img style={{ width: "25px", float: "right" }} src={Rapdf} />
                </a>
              </h3>
              <div className="d-flex actbtn">
                <Button variant="light" onClick={browseClick}>

                  <FontAwesomeIcon icon={faPaperclip} /> Attach
                </Button>
                <Dropdown className='me-auto'>
                  <Dropdown.Toggle variant="link" id="dropdown-basic">
                    <FontAwesomeIcon icon={faGear} /> Action <FontAwesomeIcon icon={faCaretDown} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item href="#/action-1" onClick={() => sideBarDelayClick()}>
                      {selectedRowData?.delay_status == null ? (
                        <img className="delay_click" style={{ width: '18px' }} src={DelayD} alt="DelayD" />
                      ) : (
                        <img className="delay_click" style={{ width: '18px' }} src={DelayA} alt="DelayA" />
                      )} Delay
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-2" onClick={() => sideBarUpdateClick(selectedRowData.order_id, 'S')}>
                      <img className="" style={{ width: '18px' }} src={Planned} alt="" /> RFP Update
                    </Dropdown.Item>
                    <Dropdown.Item href="#/action-3" onClick={() => sideBarTripStatusClick()}>
                      <img className="" src={Tripimg} alt="" /> Time Stamps
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
                {/* <Dropdown>
                                    <Dropdown.Toggle variant="light" id="dropdown-basic" >
                                        <FontAwesomeIcon icon={faBolt} /> Actions <FontAwesomeIcon icon={faChevronDown} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                        <Dropdown.Item >option</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> */}
              </div>
            </div>
            <div className="d-flex justify-content-between my-3">
              <div className="order_view">
                <h3>{selectedRowData?.loading_station}</h3>
                {/* <span>{selectedRowData?.loading_name}</span> */}
                <span>
                  {selectedRowData?.loading_name &&
                    selectedRowData?.loading_name.length > 20
                    ? `${selectedRowData?.loading_name.slice(0, 20)}...`
                    : selectedRowData?.loading_name}
                </span>
                <div className="mt-3">
                  <p>
                    Scheduled -
                    <b>
                      {selectedRowData?.loading_date_scheduled}
                      <span></span>
                    </b>
                    {/*CEST*/}
                  </p>
                  <p>
                    Actual -
                    <b>
                      {selectedRowData?.loading_date_actual} <span></span>
                    </b>
                    {/*CEST*/}
                  </p>
                </div>
              </div>
              <div className="order_middle">
                <p>
                  <img src={Cargotruck} />
                </p>
                <span>{selectedRowData?.truck_number}</span>
              </div>
              <div className="order_view">
                <h3>{selectedRowData?.unloading_station}</h3>
                {/* <span>{selectedRowData?.unloading_name}</span> */}
                <span>
                  {selectedRowData?.unloading_name &&
                    selectedRowData?.unloading_name.length > 20
                    ? `${selectedRowData?.unloading_name.slice(0, 20)}...`
                    : selectedRowData?.unloading_name}
                </span>
                <div className="mt-3">
                  <p>
                    Scheduled -
                    <b>
                      {selectedRowData?.unloading_date_scheduled}
                      <span></span>
                    </b>
                    {/*CEST*/}
                  </p>
                  <p>
                    ETA -
                    <b>
                      {selectedRowData?.unloading_date_actual} <span></span>
                    </b>
                    {/*CEST*/}
                  </p>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <ProgressBar animated now={50} style={{ height: "5px" }} />
            </div>
            <div className="mrn_edit">
              <ul>
                <li>
                  <span>MRN</span>
                  <Form.Control
                    type="text"
                    placeholder="MRN"
                    name="mrn"
                    disabled={editMrnCrm !== "mrn"}
                    onChange={changeMrnCrm}
                    value={mrnCrm?.mrn}
                  />
                  <Link to="#" className="barcode">
                    <FontAwesomeIcon icon={faBarcode} />
                  </Link>
                  {editMrnCrm !== "mrn" ? (
                    <Link to="#" onClick={() => handleEdtitMrnCrm("mrn")}>
                      <FontAwesomeIcon icon={faPencil} />
                    </Link>
                  ) : (
                    <Link to="#" onClick={updateMrnCrm}>
                      <FontAwesomeIcon icon={faCircleCheck} />
                    </Link>
                  )}
                </li>
                {/* <li>
                                            <span>CRM</span>
                                            <Form.Control type="text" placeholder="CRM" name='crm' disabled={editMrnCrm !== 'crm'} onChange={changeMrnCrm} value={mrnCrm?.crm} />
                                            {editMrnCrm !== 'crm' ?
                                                <Link to='#' onClick={() => handleEdtitMrnCrm('crm')}><FontAwesomeIcon icon={faPencil} /></Link>
                                                :
                                                <Link to='#' onClick={updateMrnCrm}><FontAwesomeIcon icon={faCircleCheck} /></Link>
                                            }
                                        </li> */}
              </ul>
            </div>

            <div className="movment_history">
              <h3>Status Updates</h3>
              {/*<Link to='#' onClick={movementHistoryClick}>View All</Link>*/}
            </div>
            <div className="movment_list">
              <ul>
                {selectedRowData?.status_updates &&
                  selectedRowData?.status_updates.map((history, index) => (
                    <li>
                      <span className="movem w-auto">{history.status}</span>
                      <span className="mvdate">
                        {history.date}&nbsp;&nbsp;&nbsp;&nbsp;{history.time}
                      </span>
                      {/* <Link to='#' >Details</Link> onClick={() => handleDetailsClick(history)} */}
                    </li>
                  ))}
              </ul>
            </div>
            <ImageUpload
              ref={imageUploadRef}
              attachable_type={"rfs_order"}
              attachable_id={selectedRowData?.order_id}
              attachments={selectedRowData?.attachments}
              onDeleteSuccess={() => loadDetails(selectedRowData?.order_id)}
            />
            <ActivityComments
              commentable_type={"rfs_order"}
              commentable_id={selectedRowData?.order_id}
              allactivities={selectedRowData?.activities}
              onReloadDetails={() => loadDetails(selectedRowData?.order_id)}
            />
          </div>
          <div className="trashdonload mt-3">
            {/* <Row className='mb-3'>
                                    <Col md={6}>
                                        <div className='nestedtabs rounded load_address'>
                                            <h3>Loading Address</h3>
                                            <h4>{selectedRowData?.loading_station}</h4>
                                            <p>{selectedRowData?.loading_name} 
                                                <span>{selectedRowData?.loading_location}</span>
                                            </p>

                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className='nestedtabs rounded load_address'>
                                            <h3>Unloading Address</h3>
                                            <h4>{selectedRowData?.unloading_station}</h4>
                                            <p>{selectedRowData?.unloading_name}
                                                <span>{selectedRowData?.unloading_location}</span>
                                            </p>

                                        </div>
                                    </Col>
                                </Row> */}
            <Row className="mb-3">
              <Col md={6}>
                <div className="rounded load_address">
                  <Row>
                    <Col md={7}>
                      <div>
                        <h3>Loading Address</h3>
                        <h4>{selectedRowData?.loading_station}</h4>
                        <p>
                          {selectedRowData?.loading_name}
                          <span>{selectedRowData?.loading_location}</span>
                        </p>
                      </div>
                      <div className='mt-3'>
                        <h3>Delay Status</h3>
                        <p>{Array.isArray(selectedRowData?.delay_status) ? selectedRowData.delay_status.join(', ') : selectedRowData?.delay_status}</p>
                      </div>

                    </Col>
                    <Col md={5}>
                      <div>
                        <div className="d-flex justify-content-between loding_time">
                          <h3>Time Stamps</h3>
                          <span>{selectedRowData?.loading_edit === 1 && (
                            <FontAwesomeIcon
                              icon={faPen}
                              onClick={() => sideBarTripStatusClick()}
                            />
                          )}</span>
                        </div>
                        <ul className="off_load">
                          <li>
                            <span>Office In: </span>
                            <span>
                              {selectedRowData?.loading_office_in}
                            </span>
                          </li>
                          <li>
                            <span>Office Out: </span>
                            <span>
                              {selectedRowData?.loading_office_out}
                            </span>
                          </li>
                          <li>
                            <span>Start Loading: </span>
                            <span>{selectedRowData?.loading_start}</span>
                          </li>
                          <li>
                            <span>End Loading: </span>
                            <span>{selectedRowData?.loading_end}</span>
                          </li>
                        </ul>
                      </div>
                      <div className='mt-3'>
                        <h3>Delay Remarks</h3>
                        <p>{selectedRowData?.delay_remarks}</p>
                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col md={6}>
                <div className="rounded load_address h-100">
                  <Row>
                    <Col md={7}>
                      <div>
                        <h3>Unloading Address</h3>
                        <h4>{selectedRowData?.unloading_station}</h4>
                        <p>
                          {selectedRowData?.unloading_name}
                          <span>{selectedRowData?.unloading_location}</span>
                        </p>
                      </div>
                      <div className='mt-3'>
                        <h3>Delay Status</h3>

                      </div>

                    </Col>
                    <Col md={5}>
                      <div>
                        <div className="d-flex justify-content-between loding_time">
                          <h3>Time Stamps</h3>
                          <span>{selectedRowData?.unloading_edit === 1 && (
                            <FontAwesomeIcon
                              icon={faPen}
                              onClick={() => sideBarTripStatusClick()}
                            />
                          )}</span>
                        </div>
                        <ul className="off_load">
                          <li>
                            <span>Office In: </span>
                            <span>
                              {selectedRowData?.unloading_office_in}
                            </span>
                          </li>
                          <li>
                            <span>Office Out: </span>
                            <span>
                              {selectedRowData?.unloading_office_out}
                            </span>
                          </li>
                          <li>
                            <span>Start Loading: </span>
                            <span>{selectedRowData?.unloading_start}</span>
                          </li>
                          <li>
                            <span>End Loading: </span>
                            <span>{selectedRowData?.unloading_end}</span>
                          </li>
                        </ul>
                      </div>
                      <div className='mt-3'>
                        <h3>Delay Remarks</h3>

                      </div>
                    </Col>
                  </Row>
                </div>
              </Col>
            </Row>
            <div ref={gridRef} className="bookinggrid"></div>
          </div>
        </div>
      </div>
      {/* </div>
      </div> */}
      <Modal show={schdlModal} onHide={() => { setSchdlModal(false); setSelectedOrderId(null); }} className='addfrom change_type' centered>
        <Modal.Header closeButton>
        </Modal.Header>
        <Modal.Body>
          {schdlModalData === 'SCH' &&
            <>
              <h3>Handling Time</h3>
              <p>Update the truck order status below</p>

              {/* <h3>Time Overview</h3>
                        <p>Overview of truck order</p> */}

              <div className='scdule_pop mb-3'>
                <h5>Trip Details</h5>
                <Row>
                  <Col md={6}>
                    <p className="text-start"><strong>Gate In: </strong> {changedData?.gateIn?.slice(0, 16)} </p>
                  </Col>
                  <Col md={6}>
                    <p className="text-start"><strong>Gate Out: </strong> {changedData?.gateOut?.slice(0, 16)} </p>
                  </Col>
                </Row>
              </div>
              <div className='scdule_pop'>
                <h5>Orders Time Overview</h5>
                <Table hover>
                  <thead>
                    <tr>
                      <th>Order No</th>
                      <th>Truck No</th>
                      <th>Vehicle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderVehicle?.map((truck) => (
                      <tr key={truck.id}>
                        <td>{truck.order_number}</td>
                        <td>{truck.truck_number}</td>
                        <td>{truck.vehicle_id}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>

                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                  <Form.Label>Office In:</Form.Label>
                  <input type="datetime-local" name="officeIn" className='form-control' value={changedData.officeIn} onChange={handleChange} placeholder="Office In" />
                </Form.Group>

                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                  <Form.Label>Office Out: </Form.Label>
                  <input type="datetime-local" name="officeOut" className='form-control' value={changedData.officeOut} onChange={handleChange} placeholder="Office Out" />
                </Form.Group>

              </div>
              <div className="mt-3">

                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                  <Form.Label>Start Loading:</Form.Label>
                  <input type="datetime-local" name="startLoading" className='form-control' value={changedData.startLoading} onChange={handleChange} placeholder="Start Loading" />
                </Form.Group>

                <Form.Group className="mb-2" controlId="exampleForm.ControlInput1">
                  <Form.Label>End Loading:</Form.Label>
                  <input type="datetime-local" name="endLoading" className='form-control' value={changedData.endLoading} onChange={handleChange} placeholder="End Loading" />
                </Form.Group>

              </div>
            </>
          }
          {schdlModalData === 'DEL' &&
            <>
              <h3>Irregularity Status</h3>
              <p>Update the Irregularity status below</p>

              <div className='scdule_pop mb-3'>
                <h5>Orders Overview</h5>
                <Table hover>
                  <thead>
                    <tr>
                      <th>Order No</th>
                      <th>Truck No</th>
                      <th>Vehicle</th>
                      <th>Delay</th>
                    </tr>
                  </thead>
                  <tbody>
                    {orderVehicle?.map((truck) => {
                      const hasData = changedData.orders?.[truck.order_id];
                      const isSelected = selectedOrderId === truck.order_id;

                      return (
                        <tr
                          key={truck.id}
                          onClick={() => setSelectedOrderId(truck.order_id)}
                          className={` ${isSelected ? 'bg-selected' : hasData ? 'bg-data' : 'bg-transparent'
                            }`}
                        >
                          <td>{truck.order_number}</td>
                          <td>{truck.truck_number}</td>
                          <td>{truck.vehicle_id}</td>
                          <td>
                            {truck.delay_status == null ? (
                              <img
                                className="jqx-grid-cell-left-align delay_click"
                                style={{ width: '25px' }}
                                src={DelayD}
                                alt="DelayD"
                              />
                            ) : (
                              <img
                                className="jqx-grid-cell-left-align delay_click"
                                style={{ width: '25px' }}
                                src={DelayA}
                                alt="DelayA"
                              />
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              {selectedOrderId && (
                <>
                  <div className='scdule_pop mb-3'>
                    <h5>Delay Status ({selectedOrder?.order_number})</h5>
                    <Select
                      isMulti
                      options={delayOptions}
                      onChange={(selectedOptions) => {
                        const newOrders = { ...changedData.orders };
                        newOrders[selectedOrderId] = {
                          ...(newOrders[selectedOrderId] || {}),
                          delay_status: selectedOptions.map((option) => option.value),
                        };
                        setChangedData((prev) => ({
                          ...prev,
                          orders: newOrders,
                        }));
                      }}
                      placeholder="Delay Status"
                      className='rfs_autoslct'
                      name="delay_status"
                      value={delayOptions.filter((option) =>
                        changedData.orders?.[selectedOrderId]?.delay_status?.includes(option.value)
                      )}
                    />
                  </div>

                  <div className='scdule_pop mb-3'>
                    <h5>Delay Remarks ({selectedOrder?.order_number})</h5>
                    <textarea
                      className="form-control"
                      placeholder="Enter delay remarks"
                      value={changedData.orders?.[selectedOrderId]?.delay_remarks || ''}
                      onChange={(e) => {
                        const newOrders = { ...changedData.orders };
                        newOrders[selectedOrderId] = {
                          ...(newOrders[selectedOrderId] || {}),
                          delay_remarks: e.target.value,
                        };
                        setChangedData((prev) => ({
                          ...prev,
                          orders: newOrders,
                        }));
                      }}
                    />
                  </div>
                </>
              )}
            </>
          }
        </Modal.Body>
        <Modal.Footer>
          <div className='d-flex w-50 mx-auto are_bottom'>
            <Button variant="primary" onClick={schdlModalData === 'SCH' ? updateTime : updateIrregularity}>
              Update Status
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      <Modal show={isModal} onHide={closeModal} className="addfrom " centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Order Status</Modal.Title>
          <p className='p_formal'>Update the truck order status below.</p>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col sm='7'>
              <div className='missing_info'>
                <h4>Update Document Status</h4>
                <p>Update the status of the documentation Below.</p>
                <Form.Group className='doc_status'>
                  <Form.Check
                    id="doc_status_open"
                    label="Open"
                    type='radio'
                    name='doc_status'
                    value="O"
                    checked={docStatus === 'O'}
                    onChange={handleRadioChange}
                  />
                  <Form.Check
                    id="doc_status_processing"
                    label="Processing"
                    type='radio'
                    name='doc_status'
                    value="P"
                    checked={docStatus === 'P'}
                    onChange={handleRadioChange}
                  />
                  <Form.Check
                    id="doc_status_completed"
                    label="Completed"
                    type="radio"
                    name="doc_status"
                    value="C"
                    checked={docStatus === "C"}
                    onChange={handleRadioChange}
                  />
                </Form.Group>
              </div>
              <div className='missing_info mt-3 mb-0'>
                <h4>RCF Status</h4>
                <p>Update the RCF status of the shipment bellow.</p>
                <div>
                  <Table className='awbset'>
                    <thead>
                      <tr>
                        <th>Awb no.</th>
                        <th>Status</th>
                        <th>PCS</th>
                        <th>RCF</th>
                        <th>MAN</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {statusData?.map((data, index) => (

                        <tr key={index}>{console.log('data', data)}
                          <td>{data.airway_bill}</td>
                          <td>
                            {data.pick_status?.map((status, index) => (
                              <span className={status.color_status || ''}>{status.status || ''}</span>
                            ))}
                            {/* <span className='rcf_cl'>RCF</span> <span className='msca_cl'>MSCA</span>*/}
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              placeholder=""
                              value={data.pieces}
                              disabled // ={editStatusIndex !== index}
                              className='' // {editStatusIndex === index ? 'awbset_edit' : ''}
                              onChange={(e) => handleFieldChange(index, 'pieces', e.target.value)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              placeholder=""
                              value={data.rcf}
                              disabled={editStatusIndex !== index}
                              className={editStatusIndex === index ? 'awbset_edit' : ''}
                              onChange={(e) => handleFieldChange(index, 'rcf', e.target.value)}
                            />
                          </td>
                          <td>
                            <Form.Control
                              type="number"
                              placeholder=""
                              value={data.man}
                              disabled={editStatusIndex !== index}
                              className={editStatusIndex === index ? 'awbset_edit' : ''}
                              onChange={(e) => handleFieldChange(index, 'man', e.target.value)}
                            />
                          </td>
                          <td>{editStatusIndex !== index ? <Link to='#' onClick={() => handleEditRow(index)}><img src={pen} /></Link> : <Link to='#' onClick={handleEditCompleteRow}><FontAwesomeIcon icon={faCircleCheck} /></Link>}</td>
                        </tr>

                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Col>
            <Col sm='5'>
              <div className='missing_info h-100'>
                <h4>Order Overview</h4>
                <p>Overview of the truck order</p>
                <ul>
                  <li> <span>Order No </span><span>: {modalData?.order_number}</span> </li>
                  <li> <span>Truck No </span><span>: {modalData?.truck_number}</span> </li>
                  <li> <span>Truck Date </span><span>: {modalData?.loading_date_planned}</span> </li>
                  <li> <span>ETA Truck  </span><span>: {modalData?.unloading_date_planned}</span> </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className='w-25 mx-auto' onClick={updateStatus}>Update Status</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default OrdersViewDetails;

